import styled from 'styled-components';

import { IMainContainerStyled } from './Main.types';

export const MainContainer = styled.div<IMainContainerStyled>`
  width: 100%;
  max-height: 100%;
`;